module.exports = __webpack_public_path__ + "img/front-12.b8098820.svg";